import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import  store  from '../../../state/store';
import {ORDER_API_URL_LIST} from "@/services/routes/order";

async function getErpOrders(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(ORDER_API_URL_LIST.ERP_ORDER_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getErpOrderDetails(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(ORDER_API_URL_LIST.ERP_ORDER_DETAILS_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getB2BOrders(params, body,urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(ORDER_API_URL_LIST.ORDER_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getPendingOrders(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.PENDING_ORDERS_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getSingleOrder(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(ORDER_API_URL_LIST.ORDER_SINGLE_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}


async function getWaitingOrders(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.ORDER_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function orderApprove(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.APPROVE_ORDER_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function orderAdd(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.ADD_ORDER_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function orderErpStatusChange(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.ERP_STATUS_CHANGE_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function orderRemove(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.REMOVE_ORDER_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}
async function orderDelete(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.DELETE_ORDER_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}


async function orderUpdate(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.UPDATE_ORDER_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function orderInvoiceControl(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.INVOICE_ORDER_CONTROL_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
}
async function orderELogo(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(ORDER_API_URL_LIST.ERP_ORDER_ELOGO, params),
        post: body
    }
    return prepareRequest(config,request,false);
}
async function getDemoProjectContract(params, body,urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(ORDER_API_URL_LIST.DEMO_PROJECT_CONTRACT_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}
async function getOrdersByProjectCode(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(ORDER_API_URL_LIST.ORDER_LIST_BY_PROJECT_CODE_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}

async function orderDeliveryDateChange(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.ORDER_DELIVERY_DATE_CHANGE, params, urlSegments),
        post: body
    }
    return prepareRequest(config,request,false);
    }
    async function getPendingOrdersSupplier(params, body) {
        let config= {
            headers:{
                Authorization: "Bearer " + store.state.auth.token
            }
        };
        let request = {
            method: "GET",
            url: setParamsToURL(ORDER_API_URL_LIST.GET_PENDING_ORDERS_SUPPLIER,params),
            post: body
        }
        return prepareRequest(config,request,false);
    }

    async function getPurchaseOrderList(params,body) {
        let config= {
            headers:{
                Authorization: "Bearer " + store.state.auth.token
            }
        };
        let request = {
            method: "GET",
            url: setParamsToURL(ORDER_API_URL_LIST.GET_PURCHASE_ORDER_LIST,params),
            post: body
        }
        return prepareRequest(config,request,false);
    }

    async function getPurchaseOrderSingle(params,body,urlSegments) {
        let config= {
            headers:{
                Authorization: "Bearer " + store.state.auth.token
            }
        };
        let request = {
            method: "GET",
            url: setParamsToURL(ORDER_API_URL_LIST.GET_PURCHASE_ORDER_SINGLE,params,urlSegments),
            post: body
        }
        return prepareRequest(config,request,false);
    }

    async function purchaseOrderAdd(params,body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
        };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.ADD_PURCHASE_ORDER, params),
        post: body
    }
        return prepareRequest(config, request);
    }

async function purchaseOrderDelete(params,body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.DELETE_PURCHASE_ORDER, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function orderStatusChange(params,body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.ORDER_STATUS_CHANGE, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function itemStatusChange(params,body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.ITEM_STATUS_CHANGE, params),
        post: body
    }
    return prepareRequest(config, request);

}

async function purchaseOrderApprove(params,body,urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(ORDER_API_URL_LIST.APPROVE_PURCHASE_ORDER, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}

export {
    getErpOrders,
    getB2BOrders,
    getWaitingOrders,
    getErpOrderDetails,
    getSingleOrder,
    orderApprove,
    orderErpStatusChange,
    orderUpdate,
    getPendingOrders,
    orderAdd,
    orderInvoiceControl,
    orderELogo,
    getDemoProjectContract,
    getOrdersByProjectCode,
    orderDelete,
    orderRemove,
    orderDeliveryDateChange,
    getPendingOrdersSupplier,
    getPurchaseOrderList,
    getPurchaseOrderSingle,
    purchaseOrderAdd,
    purchaseOrderDelete,
    orderStatusChange,
    itemStatusChange,
    purchaseOrderApprove
};
